
import React, { Fragment } from 'react'
import DataHeader from 'components/datatable/DataHeader'
import DataRow from 'components/datatable/DataRow'

const DataTable = (props) => {
    const { data, dlist, paging, changeSort, coltype, ...rest } = props
    const columns = dlist?.columns
    const page = paging?.page
    const perpage = paging?.perpage
    const rowno = (page - 1) * perpage + 1
    return (
        <Fragment>
            <div className="col-12 table-responsive">
                <table className="table sortable table-bordered table-hover table-striped table-condensed" >
                    <thead>
                        <DataHeader changeSort={changeSort} sort_by={dlist?.sort_by} columns={columns} coltype={coltype} headerGroups={dlist?.headerGroups} />
                    </thead>
                    <tbody>
                        {data && data.map((item, i) =>
                            <DataRow rowno={rowno + i} key={"rowdata-" + i} columns={columns} item={item} coltype={coltype} />
                        )}
                    </tbody>
                </table >
            </div>
        </Fragment >
    )
}

DataTable.defaultProps = {
    data: null,
    dlist: null,
    coltype: null,
    paging: { "page": 1, "perpage": 10 },
    changeSort: () => { }
}

export default DataTable
